import React from 'react';

import './real-logos.scss';



const DecorRealLogos = () => {

    return (
        <>
            <div className='logos' id='real-logos'>
                <a href='https://www.artlebedev.ru/shuka/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_1.png"/>
                </a>
                <a href='https://www.artlebedev.ru/rumyantsevo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_2.png"/>
                </a>
                <a href='https://www.artlebedev.ru/federationtower/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_3.png"/>
                </a>
                <a href='https://www.artlebedev.ru/petrovka-xx/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_4.png"/>
                </a>
                <a href='https://www.artlebedev.ru/iq-quarter/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_5.png"/>
                </a>
                <a href='https://www.artlebedev.ru/cian/logo2/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_6.png"/>
                </a>
                <a href='https://www.artlebedev.ru/tashir/stellar-city/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_7.png"/>
                </a>
                <a href='https://www.artlebedev.ru/tashir/legacy/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/real/real_0.png"/>
                </a>
            </div>
        </>
    );
}

export default DecorRealLogos;
